<template>
  <van-popup
    v-model="showPopup"
    class="tips-bottom-popup"
    position="bottom"
  >
    <div class="tips-bottom-popup-wrap">
      <div class="tips-bottom-popup-title">
        用券说明
        <img
          class="close-btn"
          src="@/assets/img/chargingVoucher/icon-bottom-popup-close.png"
          alt=""
          @click="showPopup = false"
        >
      </div>
      <div class="tips-bottom-popup-content">
        <div
          class="content"
          v-if="moreDescription"
          v-html="htmlStr"
        />
        <!-- 暂无说明 -->
        <div
          class="flex-center-center"
          v-else
        >暂无说明</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'TipsBottomPopup',
  props: {
    moreDescription: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPopup: false
    };
  },
  computed: {
    htmlStr() {
      let html = this.moreDescription || '';

      html = html.replace(/<img/g, '<img style="max-width:100%;height:auto;object-fit:contain;display: block;margin:0 auto;"');

      return html;
    }
  },
  methods: {
    openPopup() {
      this.showPopup = true;
      this.$emit('open');
    },
    closePopup() {
      this.showPopup = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.tips-bottom-popup {
  max-height: 70vh;

  .tips-bottom-popup-wrap {
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;
    max-height: 70vh;
    min-height: 100px;
    box-sizing: border-box;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;

    .tips-bottom-popup-title {
      font-size: 36px;
      color: #383838;
      letter-spacing: -1.66px;
      text-align: center;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e6e6e6;
      height: 114px;
      position: relative;
      flex-shrink: 0;

      .close-btn {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 32px;
        object-fit: contain;
      }
    }
    .tips-bottom-popup-content {
      font-size: 32px;
      color: #646464;
      letter-spacing: -1.48px;
      font-weight: 400;
      padding: 32px;
      box-sizing: border-box;
      width: 100%;
      overflow: scroll;
      line-height: 45px;
      flex: 1;
    }
  }
}
.content {
  line-height: 2;
}
.van-popup {
  background-color: unset;
}
.flex-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
